import {
    KeycloakInstance,
    KeycloakLoginOptions,
    KeycloakProfile,
    KeycloakInitOptions,
} from 'keycloak-js';

import request from 'yeself-common/utils/RequestUtils';

import { SecurityBusActionTypes } from './types';

/**
 * If the token expires within minValidity seconds the token is refreshed
 */
const MIN_VALIDITY = 30;

export const init = (keycloak: KeycloakInstance, options: KeycloakInitOptions): Promise<boolean> =>
    keycloak.init(options);

export const loadUserProfile = (keycloak: KeycloakInstance): Promise<KeycloakProfile> =>
    keycloak.loadUserProfile();

export const loadUserInfo = (keycloak: KeycloakInstance): Promise<KeycloakProfile> =>
    keycloak.loadUserInfo();

export const updateToken = (keycloak: KeycloakInstance, minValidity = 5): Promise<boolean> =>
    keycloak.updateToken(minValidity);

export const createAccountUrl = (keycloak: KeycloakInstance): string => keycloak.createAccountUrl();

export const createLoginUrl = (keycloak: KeycloakInstance, options: KeycloakLoginOptions): string =>
    keycloak.createLoginUrl(options);

export const login = (keycloak: KeycloakInstance, options?: KeycloakLoginOptions): Promise<void> =>
    keycloak.login(options);

export const logout = (keycloak: KeycloakInstance, options?): Promise<void> => keycloak.logout(options);

export const clearToken = (keycloak: KeycloakInstance): void => keycloak.clearToken();

export const getAuthIframe = (): HTMLIFrameElement | null =>
    document.getElementById('yeself-auth') as HTMLIFrameElement | null;

export const reloadAuthIframe = (): void => {
    const iframe = getAuthIframe();

    if (iframe) {
        const { src } = iframe;

        iframe.src = src;
    }
};

export const postMessageToAuthIframe = (message: SecurityBusActionTypes): void => {
    const iframe = getAuthIframe();

    iframe?.contentWindow?.postMessage(message, '*');
};

export const setRequestAuth = (keycloak: KeycloakInstance): void =>
    request.setAuth({
        bearerToken: () => keycloak.token,
        refreshAuth: () => keycloak.updateToken(MIN_VALIDITY),
        errorCallback: () => keycloak.clearToken(),
    });
